/**
 * Initialize Flickity carousels from elements with data-flickity.
 * Load this after flickity.pkgd.min.js (defer, same order).
 */
(function () {
  function initFlickityCarousels() {
    if (typeof window.Flickity === 'undefined') return;
    document.querySelectorAll('[data-flickity]').forEach(function (el) {
      if (window.Flickity.data(el)) return;
      try {
        var opts = JSON.parse(el.getAttribute('data-flickity') || '{}');
        new window.Flickity(el, opts);
      } catch (e) {
        console.warn('Flickity init failed:', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFlickityCarousels);
  } else {
    initFlickityCarousels();
  }

  document.addEventListener('shopify:section:load', initFlickityCarousels);
})();
